// extracted by mini-css-extract-plugin
module.exports = {"root":"Facts_root__BJ7CI","factsWrapper":"Facts_factsWrapper__VQDIa","richText":"Facts_richText__dnEaB","factCard":"Facts_factCard__wXCa_"};